import React from "react";
import type { GatsbyBrowser } from "gatsby";
import Root, { type RootProps } from "./src/layouts/partials/root";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = (props) => (
  <Root {...(props as RootProps)}>{props.element}</Root>
);
